export default {
  reportName: 'VOLUME_PERFORMANCE',
};
